type Council = {
	displayName: string;
	postcodes: string[];
};

type GoogleMapsCouncilMatch = string;

type State = Record<GoogleMapsCouncilMatch, Council>;

type StateCouncils = Record<string, State>;

const councilCodes: StateCouncils = {
	NSW: {
		'Central Coast Council': {
			displayName: 'Central Coast Council',
			postcodes: [
				'2083',
				'2257',
				'2261',
				'2250',
				'2258',
				'2262',
				'2251',
				'2259',
				'2263',
				'2256',
				'2260',
				'2775',
			],
		},
		Newcastle: {
			displayName: 'Newcastle Council',
			postcodes: ['2300', '2308', '2292', '2302', '2293', '2296', '2287', '2289'],
		},
		Mosman: {
			displayName: 'Mosman Council',
			postcodes: ['2088'],
		},
		'Tamworth Regional': {
			displayName: 'Tamworth Regional Council',
			postcodes: ['2340', '2342', '2343', '2344', '2345', '2346', '2352', '2353', '2355'],
		},
	},
};

const postcodesToCouncilName: Record<string, string> = {};

Object.values(councilCodes).forEach((stateCouncils) => {
	Object.values(stateCouncils).forEach((council) => {
		council.postcodes.forEach((councilCode) => {
			postcodesToCouncilName[councilCode] = council.displayName;
		});
	});
});

export const findCouncilByNameAndState = (
	councilName: string,
	state: string
): string | undefined => {
	const stateDetails = councilCodes[state];

	if (stateDetails) {
		const stateCouncils = Object.entries(stateDetails);
		const matchedCouncil = stateCouncils.find(
			([councilMatchName]) => councilMatchName === councilName
		);
		return matchedCouncil?.[1].displayName;
	}
};

export const findCouncilByPostcode = (postcode: string): string | undefined => {
	return postcodesToCouncilName[postcode];
};

export const findCouncil = (
	councilName: string | null | undefined,
	state: string | null | undefined,
	postcode: string | null | undefined
) => {
	if (councilName && state) {
		return findCouncilByNameAndState(councilName, state);
	} else if (postcode) {
		return findCouncilByPostcode(postcode);
	} else {
		return undefined;
	}
};
